import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DigitalMenuCategoryProductApi } from 'api';

export const findDigitalMenuCategoryProductForTableList = createAsyncThunk(
  'digitalMenuCategoryProduct/findDigitalMenuCategoryProductForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryProductApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDigitalMenuCategoryProduct = createAsyncThunk(
  'digitalMenuCategoryProduct/updateDigitalMenuCategoryProduct',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;

      const response = await DigitalMenuCategoryProductApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatusDigitalMenuCategoryProduct = createAsyncThunk(
  'digitalMenuCategoryProduct/updateStatusDigitalMenuCategoryProduct',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;

      const response = await DigitalMenuCategoryProductApi.updateStatus(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  reloadFlag: boolean;
  tableList: Array<any>;
  myList: Array<any>;
  purchaseList: Array<any>;
  purchaseReloadedRow?: any;
  collaboratorList: Array<any>;
  list: Array<any>;
  isLoadingTable: boolean;
}

const initialState: IState = {
  reloadFlag: false,
  tableList: [],
  myList: [],
  purchaseList: [],
  purchaseReloadedRow: undefined,
  collaboratorList: [],
  list: [],
  isLoadingTable: true,
};

const digitalMenuCategoryProductSlice = createSlice({
  name: 'digitalMenuCategoryProduct',
  initialState,
  reducers: {
    reloadDigitalMenuCategoryProduct(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: digitalMenuCategoryProductReducer } =
  digitalMenuCategoryProductSlice;

export const { reloadDigitalMenuCategoryProduct } = actions;

export default digitalMenuCategoryProductReducer;
